import React from 'react';
import { Box, Text, Flex, Button, Badge } from '@chakra-ui/react';
import { useUpdateDecisionMutation } from "../app/api";
import { useSelector } from 'react-redux';
import { path } from "ramda";

export const ChosenAlternative = ({ items, items2, decision_id, order_nr, next_to_show,
  show_until, done_item, data_input, next_btn_visible, is_last }) => {

  const [moveForward] = useUpdateDecisionMutation();
  const texts = useSelector(path(["ui", "ui_texts"]));

  // Build vote counts keyed by item id, same as VoteCount
  const voteCounts = items.filter(item => item.value_text).reduce((acc, item) => {
    acc[item.id] = { text: item.value_text, count: 0 };
    return acc;
  }, {});

  (items2 || []).forEach(row => {
    if (row.value_number === 1 && voteCounts[row.input_id]) {
      voteCounts[row.input_id].count += 1;
    }
  });

  const rankedList = Object.entries(voteCounts)
    .map(([id, { text, count }]) => ({ id, text, count }))
    .sort((a, b) => b.count - a.count);

  const topCount = rankedList[0]?.count ?? 0;
  // Show all tied winners
  const winners = rankedList.filter(x => x.count === topCount && topCount > 0);

  const hide_next_btn = (done_item === null || data_input == null)
    ? (show_until > order_nr)
    : !next_btn_visible;

  return (
    <Box>
      {winners.length === 0 ? (
        <Text color="gray.400" fontSize="sm">{texts.no_votes || "No votes yet"}</Text>
      ) : winners.length === 1 ? (
        <Box>
          <Text fontSize="xl" fontWeight="bold">{winners[0].text}</Text>
        </Box>
      ) : (
        <Box>
          <Badge colorScheme="orange" mb={2}>{texts.tie || "Tie"}</Badge>
          {winners.map(w => (
            <Box key={w.id} mb={1}>
              <Text fontSize="xl" fontWeight="bold">{w.text}</Text>
            </Box>
          ))}
        </Box>
      )}
      {(is_last || hide_next_btn) ? null : (
        <Flex mt={3} gap={2}>
          <Button size="md" colorScheme="blue" onClick={() => {
            moveForward({
              id: decision_id,
              done: order_nr,
              show_until: next_to_show
            });
          }}>
            {texts.next}
          </Button>
        </Flex>
      )}
    </Box>
  );
};
